import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import WeeklyView from './WeeklyView';
import {push, post, getNameForType} from '../../util/Utility';
import {FieldGroup, CCOButton, CCOAlert, Select} from '../../util/Components';
import moment from 'moment';

export default class WeeklyPager extends Component {

  constructor(props) {
    super(props)

    this.state = {
      newWeekly: {
        title: "",
        show: false,
        type: this.props.ministry.type
      },
      noNameAlert: false,
      key: this.props.ministry.weekly ? Object.keys(this.props.ministry.weekly)[0] : "+"
    }
  }

  addWeekly() {
    if (this.state.newWeekly.title !== "") {
      push('weekly', this, {
        title: this.state.newWeekly.title,
        base: {
          location: "f",
          atCCO: true,
          interval: 'weekly',
          date: moment().hour(18).startOf('hour').unix(),
          endDate: moment().hour(20).startOf('hour').unix(),
          day: 4
        },
        ministryID: this.props.ministry.key,
        type: this.state.newWeekly.type
      }).then(obj => {
        let newMinistry = this.props.ministry;
        if (!newMinistry.weekly)
          newMinistry.weekly = {};
        newMinistry.weekly[obj.key] = this.state.newWeekly.title;
        this.props.updateMinistry(newMinistry);
        post('ministries/' + this.props.ministry.key + '/weekly/' + obj.key, this, this.state.newWeekly.title);
        this.setState({newWeekly: {title: "", type: this.props.ministry.type}, key: obj.key});
      })
    } else {
      this.setState({noNameAlert: true});
    }
  }

  handleSelect(key) {
    this.setState({key});
  }

  render() {

    var tabs = [];

    let ministry = this.props.ministry;

    if (ministry.weekly) {
      console.log(ministry.weekly);
      Object.keys(ministry.weekly).forEach(key => {
        tabs.push(<Tab key={key} eventKey={key} title={ministry.weekly[key]}><WeeklyView archiveCallback={() => {
          let newMinistry = this.props.ministry;
          delete newMinistry.weekly[key];
          this.props.updateMinistry(newMinistry);

          let nowArray = Object.keys(ministry.weekly);
          this.setState({key: nowArray.length > 0 ? nowArray[0] : "+"})
        }} weekly={key} {...this.props} /></Tab>);
      });
    }

    tabs.push(
      <Tab key="new" eventKey="+" title="+">
        <center>
          <div style={{maxWidth: 300}}>
            <h4 style={{margin: 20}}>Add Recurring Event</h4>
            <FieldGroup id="title" label="" context={this} placeholder="New Recurring Event Title" comp="newWeekly" />
            <Select id="type" context={this} comp="newWeekly" onChange={out => console.warn(out)}>
              <option key="bible" value="bible">{getNameForType("bible")}</option>
              <option key="outreach" value="outreach">{getNameForType("outreach")}</option>
              <option key="fellowship" value="fellowship">{getNameForType("fellowship")}</option>
              <option key="prayer" value="prayer">{getNameForType("prayer")}</option>
              {this.props.ministry.key === "cco" && <option key="sunday" value="sunday">{getNameForType("sunday")}</option>}
            </Select>
            <CCOButton text="Add Recurring Event" type="primary" onClick={() => this.addWeekly()} />
            <CCOAlert in={this.state.noNameAlert} type="warning" title="Missing Title" content="Please enter a title" />
          </div>
        </center>
      </Tab>
    );

    return (
      <center>
        <div style={{maxWidth: 540, padding: 10}}>
          <div style={{height: 10}} />
          <Tabs defaultActiveKey="+" activeKey={this.state.key} onSelect={this.handleSelect.bind(this)} id="weekly-tabs">
            {tabs}
          </Tabs>
        </div>
      </center>
    )
  }

}



/** WEBPACK FOOTER **
 ** ./src/ministry/weekly/WeeklyPager.js
 **/